import { CampaignCreationChooseTypeStep } from 'modules/campaign-creation/steps/CampaignCreationChooseTypeStep';
import { CampaignCreationJobDescriptionStep } from 'modules/campaign-creation/steps/CampaignCreationJobDescriptionStep';
import { CampaignCreationEditJobDescriptionStep } from 'modules/campaign-creation/steps/CampaignCreationEditJobDescriptionStep';
import { CampaignCreationChooseRecipientsStep } from 'modules/campaign-creation/steps/CampaignCreationChooseRecipientsStep';
import { CampaignCreationGenerateJobDescriptionAndQuestions } from 'modules/campaign-creation/steps/CampaignCreationGenerateJobDescriptionAndQuestions';
import { CampaignCreationImportCandidatesStep } from 'modules/campaign-creation/steps/CampaignCreationImportCandidatesStep';
import { CampaignCreationAnalysisSetupStep } from 'modules/campaign-creation/steps/CampaignCreationAnalysisSetupStep';
import { CampaignCreationQuestionsAndDocumentsStep } from 'modules/campaign-creation/steps/CampaignCreationQuestionsAndDocumentsStep';
import { CampaignCreationChannelStep } from 'modules/campaign-creation/steps/CampaignCreationChannelStep';
import { CampaignCreationCandidateApplicationStep } from 'modules/campaign-creation/steps/CampaignCreationCandidateApplicationStep';
import { CampaignCreationSetupAndSimulationStep } from 'modules/campaign-creation/steps/CampaignCreationSetupAndSimulationStep';
import { CampaignCreationAutomationStep } from 'modules/campaign-creation/steps/CampaignCreationAutomationStep';
import { CampaignCreationCreateStep } from 'modules/campaign-creation/steps/CampaignCreationCreateStep';
import { CampaignCreationEngagementDescriptionStep } from 'modules/campaign-creation/steps/CampaignCreationEngagementDescriptionStep';

const steps = [
  'CHOOSE_TYPE',
  'ENGAGEMENT_DESCRIPTION',
  'JOB_DESCRIPTION',
  'AI_GENERATE_JOB_DESCRIPTION_AND_QUESTIONS',
  'EDIT_JOB_DESCRIPTION',
  'QUESTIONS_AND_DOCUMENTS',
  'CHOOSE_RECIPIENTS',
  'ANALYSIS_SETUP',
  'IMPORT_CANDIDATES',
  'CANDIDATE_APPLICATION',
  'CHANNEL',
  'SETUP_AND_SIMULATION',
  'AUTOMATIONS',
  'CREATE'
] as const;
export type CampaignCreationStep = (typeof steps)[number];

type CampaignCreationStepComponent = {
  [K in CampaignCreationStep]: React.ComponentType;
};

export const campaignCreationSteps: CampaignCreationStepComponent = {
  CHOOSE_TYPE: CampaignCreationChooseTypeStep,
  ENGAGEMENT_DESCRIPTION: CampaignCreationEngagementDescriptionStep,
  JOB_DESCRIPTION: CampaignCreationJobDescriptionStep,
  AI_GENERATE_JOB_DESCRIPTION_AND_QUESTIONS:
    CampaignCreationGenerateJobDescriptionAndQuestions,
  EDIT_JOB_DESCRIPTION: CampaignCreationEditJobDescriptionStep,
  QUESTIONS_AND_DOCUMENTS: CampaignCreationQuestionsAndDocumentsStep,
  CHOOSE_RECIPIENTS: CampaignCreationChooseRecipientsStep,
  ANALYSIS_SETUP: CampaignCreationAnalysisSetupStep,
  IMPORT_CANDIDATES: CampaignCreationImportCandidatesStep,
  CHANNEL: CampaignCreationChannelStep,
  CANDIDATE_APPLICATION: CampaignCreationCandidateApplicationStep,
  SETUP_AND_SIMULATION: CampaignCreationSetupAndSimulationStep,
  AUTOMATIONS: CampaignCreationAutomationStep,
  CREATE: CampaignCreationCreateStep
};
